module.exports = __webpack_public_path__ + "static/img/patentright-1.926ff92.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/business/patentright-1.png
// module id = D3ab
// module chunks = 0